import { render, staticRenderFns } from "./AuthProjectModal.vue?vue&type=template&id=0aefb91d&scoped=true&"
import script from "./AuthProjectModal.vue?vue&type=script&lang=js&"
export * from "./AuthProjectModal.vue?vue&type=script&lang=js&"
import style0 from "./AuthProjectModal.vue?vue&type=style&index=0&id=0aefb91d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aefb91d",
  null
  
)

export default component.exports